import React, { useState, createContext, Fragment } from "react";
import { Col, Container, Row,  Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ClassesPopularity from "./ClassesPopularity";
import InstructorsEfficiency from "./InstructorsEfficiency";
import moment from "moment";

export const ReportsContext = createContext();

const Reports = () => {
    const { t } = useTranslation();
    const [startDate, setStartDate] = useState(moment().subtract(30, "days").format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [currentTab, setCurrentTab] = useState("classes");

    const tabs = [
        {
            key: "classes",
            title: t("classes.classesPopularity"),
            module: <ClassesPopularity />,
        },
        {
            key: "efficiency",
            title: t("reports.instructorsEfficiency"),
            module: <InstructorsEfficiency />,
        },
    ];

    return (
        <ReportsContext.Provider
            value={{
                startDate,
                setStartDate,
                endDate,
                setEndDate,
            }}
        >
            <Container fluid="lg">
                <Row>
                    <Col xs={12} className="px-4 mb-4 px-lg-2">
                        <h1 className="h4 d-inline-block m-0 mt-4">{t("reports.reports")}</h1>
                    </Col>
                    <Col xs={12} className="px-0 mb-3">
                        {tabs.map((t, k) => (
                            <Button key={k} variant="outline-primary" active={currentTab === t.key} className="mx-2 d-inline-block mb-3" onClick={() => setCurrentTab(t.key)}>
                                {t.title}
                            </Button>
                        ))}
                        {tabs.map((t, k) => (
                            <Fragment key={k}>{currentTab === t.key && t.module}</Fragment>
                        ))}
                    </Col>
                </Row>
            </Container>
        </ReportsContext.Provider>
    );
};

export default Reports;
